export const appLogo = require("../assets/images/logo.png");

export const Url = process.env.REACT_APP_BASE_URL;
export const ENCRYPTKEY = "itstopsecretrequest";
export const googleUrl = process.env.REACT_APP_GOOGLE_PLAY_URL;
export const appleUrl = process.env.REACT_APP_APPLE_URL;
export const IS_LOG_ROCKET_ON = process.env.REACT_APP_LOG_ROCKET === "ON";
export const REACT_APP_LOG_ROCKET_APP_ID = process.env.REACT_APP_LOG_ROCKET_APP_ID;

const size = {
  mobileS: "321px",
  mobileM: "376px",
  mobileL: "426px",
  tablet: "767px",
  laptop: "1025px",
  laptopL: "1441px",
  desktop: "2561px",
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
};

export const PREFERENCE_TYPE = {
  BY_TIME: "TIME",
  ALL: "ALL",
};

export const INIT_FILTERS = {
  speciality: [],
  language: [],
  timezone: null,
};

export const INPERSON_VISIT_TYPE = "initial-in-person";

export const SELF_PAY_INSURANCE_ID =
  process.env.REACT_APP_SELF_PAY_INSURANCE_ID;

export const API_SERVICE_ID = 1;

export const REGISTRATION_SETUP_TOTAL_STEPS = 7;

/** Pre-calculated widths: step N => ((N) * 100 / totalSteps)% */
export const REGISTRATION_SETUP_PROGRESS_BREAKPOINTS = Array.from(
  { length: REGISTRATION_SETUP_TOTAL_STEPS },
  (_, i) =>
    Number((((i + 1) * 100) / REGISTRATION_SETUP_TOTAL_STEPS).toFixed(2))
);

/** Progress bar width for 1-based currentStep (0 => 0%). Fallback when step has no progressPercent. */
export const getRegistrationProgressPercent = (
  currentStep,
  totalSteps = REGISTRATION_SETUP_TOTAL_STEPS
) => {
  if (currentStep === 0) {
    return 0;
  }
  return REGISTRATION_SETUP_PROGRESS_BREAKPOINTS[currentStep - 1] ?? 0;
};

/** Mockup-aligned progress width from step meta (see standalone HTML prototype). */
export const getRegistrationStepProgressPercent = (
  stepMeta,
  totalSteps = REGISTRATION_SETUP_TOTAL_STEPS
) => {
  if (typeof stepMeta?.progressPercent === "number") {
    return stepMeta.progressPercent;
  }
  return getRegistrationProgressPercent(stepMeta?.step, totalSteps);
};

export const REGISTRATION_SETUP_STEP = {
  WELCOME: 1,
  ACCOUNT: 1,
  PAYMENT: 2,
  INSURANCE: 3,
  CARD: 4,
  DIETITIAN: 5,
  APPOINTMENT: 6,
};

/** Navbar center title per screen (short page title in the amber header). */
export const REGISTRATION_SETUP_STEP_META = {
  WELCOME: {
    step: 1,
    eyebrow: "Setup · Step 1 of 7",
    navbarTitle: "HUSK Nutrition",
    navbarTitleKey: "CM_LBL_HUSK_NUTRITION",
    progressPercent: 10,
  },
  ACCOUNT: {
    step: 1,
    eyebrow: "Step 1 of 7 — Your Details",
    navbarTitle: "Create Your Account",
    navbarTitleKey: "NUTRITION_REGISTER_LBL_TITLE",
    progressPercent: 12,
  },
  PAYMENT_TYPE: {
    step: 2,
    eyebrow: "Step 2 of 7 — Payment Setup",
    navbarTitle: "Payment Setup",
    navbarTitleKey: "NUTRITION_PAYMENT_LBL_TITLE_SETUP",
    progressPercent: 25,
  },
  INSURANCE_VERIFICATION: {
    step: 3,
    eyebrow: "Step 3 of 7 — Find My Coverage",
    navbarTitle: "Find My Coverage",
    navbarTitleKey: "NUTRITION_INSDISC_LBL_HEADER",
    progressPercent: 32,
  },
  INSURANCE_INFORMATION: {
    step: 3,
    eyebrow: "Step 3 of 7 — Insurance",
    navbarTitle: "Insurance Information",
    navbarTitleKey: "NUTRITION_INSMANUAL_LBL_TITLE",
    progressPercent: 28,
  },
  INSURANCE_CHECKING: {
    step: 3,
    eyebrow: "Step 3 of 7 — Checking Coverage",
    navbarTitle: "Checking Coverage...",
    navbarTitleKey: "NUTRITION_INSDISC_LBL_VERIFYING_ELIGIBILITY",
    progressPercent: 37,
  },
  INSURANCE_CHECKING_RECHECK: {
    step: 3,
    eyebrow: "Step 3 of 7 — Re-checking Coverage",
    navbarTitle: "Checking Coverage...",
    navbarTitleKey: "NUTRITION_INSDISC_LBL_VERIFYING_PLAN_RECHECK",
    progressPercent: 37,
  },
  INSURANCE_COVERAGE_FOUND: {
    step: 3,
    eyebrow: "Step 3 of 7 — Coverage Found",
    navbarTitle: "Coverage Found",
    navbarTitleKey: "NUTRITION_INSDISC_LBL_BANNER_TITLE",
    progressPercent: 42,
  },
  CARD_ON_FILE: {
    step: 3,
    eyebrow: "Step 3 of 7 — Card on File",
    navbarTitle: "Card on File",
    navbarTitleKey: "NUTRITION_CARD_LBL_TITLE",
    progressPercent: 33,
  },
  CARD_ON_FILE_INSURANCE: {
    step: 4,
    eyebrow: "Step 4 of 7 — Card on File",
    navbarTitle: "Card on File",
    navbarTitleKey: "NUTRITION_CARD_LBL_TITLE",
    progressPercent: 50,
  },
  DIETITIAN_SELECTION: {
    step: 5,
    eyebrow: "Step 5 of 7 — Dietitian Selection",
    navbarTitle: "Choose a Dietitian",
    navbarTitleKey: "NUTRITION_RDLIST_LBL_TITLE",
    progressPercent: 71,
  },
  DIETITIAN_PROFILE: {
    step: 5,
    eyebrow: "Step 5 of 7 — Dietitian Selection",
    navbarTitle: "Dietitian Profile",
    navbarTitleKey: "NUTRITION_RDLIST_LBL_TITLE",
    progressPercent: 75,
  },
  APPOINTMENT_TIME: {
    step: 6,
    eyebrow: "Step 6 of 7 — Appointment Time",
    navbarTitle: "Select a Time",
    navbarTitleKey: "BY_RD_BTN_BROWSE_AVAILABLE_TIMES",
    progressPercent: 85,
  },
  APPOINTMENT_CONFIRMED: {
    step: 7,
    eyebrow: "Step 7 of 7 — Appointment Confirmed",
    navbarTitle: "Appointment Confirmed",
    navbarTitleKey: "NUTRITION_CONFIRM_LBL_BOOKED_TITLE",
    progressPercent: 93,
  },
  APP_DOWNLOAD: {
    step: 7,
    eyebrow: "Step 7 of 7 — Download the App",
    navbarTitle: "Download the App",
    navbarTitleKey: "NUTRITION_APPPROMO_LBL_TITLE",
    progressPercent: 100,
  },
  INSURANCE: {
    step: 4,
    eyebrow: "Step 4 of 7 — Insurance",
    navbarTitle: "Insurance Information",
    navbarTitleKey: "NUTRITION_INSMANUAL_LBL_TITLE",
    progressPercent: 28,
  },
  CARD: {
    step: 5,
    eyebrow: "Step 5 of 7 — Card on File",
    navbarTitle: "Card on File",
    navbarTitleKey: "NUTRITION_CARD_LBL_TITLE",
    progressPercent: 50,
  },
  DIETITIAN: {
    step: 6,
    eyebrow: "Step 6 of 7 — Dietitian Selection",
    navbarTitle: "Choose a Dietitian",
    navbarTitleKey: "NUTRITION_RDLIST_LBL_TITLE",
    progressPercent: 71,
  },
  APPOINTMENT: {
    step: 7,
    eyebrow: "Step 7 of 7 — Appointment Time",
    navbarTitle: "Select a Time",
    navbarTitleKey: "BY_RD_BTN_BROWSE_AVAILABLE_TIMES",
    progressPercent: 85,
  },
};
